export const calculateMonthly = (amount, deadline) => {
  if (!amount || !deadline) return 0;
  const now = new Date();
  const end = new Date(deadline);
  const months = Math.max(1, (end - now) / (1000 * 60 * 60 * 24 * 30));
  return Math.ceil(amount / months);
};

export const getMonthsRemaining = (deadline) => {
  if (!deadline) return 0;
  const now = new Date();
  const end = new Date(deadline);
  return Math.max(0, Math.round((end - now) / (1000 * 60 * 60 * 24 * 30)));
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(amount);
};

const goalCategories = [
  {
    keywords: ['japan', 'trip', 'vacation', 'travel', 'holiday', 'cruise', 'tour'],
    suffix: (pct) => pct < 50 ? " — that's like booking your flight ✈️" : " — the adventure is almost funded!"
  },
  {
    keywords: ['emergency', 'fund', 'safety', 'rainy'],
    suffix: (pct, currentSaved) => {
      const weeks = Math.floor((currentSaved / 1000) * 2); // rough heuristic
      return weeks > 0 ? ` — you've covered ~${weeks} weeks of expenses` : ' — building your safety net';
    }
  },
  {
    keywords: ['laptop', 'computer', 'macbook', 'phone', 'iphone', 'car', 'home', 'house', 'bike'],
    suffix: () => ' — getting closer to that purchase!'
  }
];

const getCategorySuffix = (goalName, pct, currentSaved) => {
  const lower = goalName.toLowerCase();
  const match = goalCategories.find(c => c.keywords.some(k => lower.includes(k)));
  return match ? match.suffix(pct, currentSaved) : '';
};

export const getMilestoneMessage = (pct, goalName = '', currentSaved = 0) => {
  if (pct === 0) return 'Just getting started!';
  if (pct >= 100) return 'Goal complete! 🎉';

  const suffix = getCategorySuffix(goalName, pct, currentSaved);

  if (pct < 25) return `You're ${pct}% there — great start!${suffix}`;
  if (pct < 50) return `You're ${pct}% there — keep it up!${suffix}`;
  if (pct < 75) return `You're ${pct}% there — over halfway!${suffix}`;
  return `You're ${pct}% there — almost there!${suffix}`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
};
